import { render, staticRenderFns } from "./activity.vue?vue&type=template&id=28e2293e&scoped=true"
import script from "./activity.vue?vue&type=script&lang=js"
export * from "./activity.vue?vue&type=script&lang=js"
import style0 from "./activity.vue?vue&type=style&index=0&id=28e2293e&prod&scoped=true&lang=css"
import style1 from "./activity.vue?vue&type=style&index=1&id=28e2293e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28e2293e",
  null
  
)

export default component.exports